import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.BulkMessageSuppliersModal.title',
    defaultMessage: 'Message suppliers on selected tasks',
  },
})
